(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NFCardQuantity = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function finiteNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalize(rawValue, rules = {}) {
    const min = finiteNumber(rules.min, 1);
    const step = Math.max(finiteNumber(rules.step, 1), 1);
    const parsedMax = rules.max === null || rules.max === undefined || rules.max === ''
      ? Infinity
      : finiteNumber(rules.max, Infinity);
    const max = parsedMax < min ? min : parsedMax;
    const raw = finiteNumber(rawValue, min);
    const stepped = min + Math.round((raw - min) / step) * step;

    return Math.min(max, Math.max(min, stepped));
  }

  function transfer(container, rawValue) {
    if (!container) return null;

    const form = container.querySelector(
      'product-form form[data-type="add-to-cart-form"], form[action*="/cart/add"]',
    );
    if (!form) return null;

    let input = container.querySelector('[name="quantity"]');
    if (!input) {
      input = container.ownerDocument.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }

    const quantity = normalize(rawValue, {
      min: input.min || 1,
      max: input.max || null,
      step: input.step || 1,
    });

    input.value = String(quantity);
    const EventConstructor = container.ownerDocument.defaultView?.Event || globalThis.Event;
    input.dispatchEvent(new EventConstructor('input', { bubbles: true }));
    input.dispatchEvent(new EventConstructor('change', { bubbles: true }));

    return { input, quantity };
  }

  return { normalize, transfer };
});
